import { useRouter } from "next/router";
import { useEffect } from "react";
import { useUserContext } from "../context/auth/user.context";
import {
  CASH_REGISTER_ROUTE,
  shouldRedirectToCashRegister,
} from "../services/cash-register-routing";

/**
 * A cash register holder has nothing to do on the visitor pages: whatever link
 * brought them there, they are sent back to the counter screen.
 */
const useRedirectCashRegisterHolder = () => {
  const { user, isLoading, isAuthenticated } = useUserContext();
  const router = useRouter();

  useEffect(() => {
    if (isLoading) return;

    if (
      !shouldRedirectToCashRegister({
        isAuthenticated,
        userRole: user?.userRole,
        pathname: router.pathname,
      })
    ) {
      return;
    }

    router.replace(CASH_REGISTER_ROUTE);
  }, [isAuthenticated, isLoading, router, user]);
};

export default useRedirectCashRegisterHolder;
